import { PanelClass } from '@mairistem/finances-utils';

class LignePanel extends PanelClass {
  // Propriété qui sert à savoir si le bloc affecte le mouvement ou les lignes
  isOnlyMouvement = false;
}

export default LignePanel;
